import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Dropzone from "react-dropzone";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
// import { styled } from "@mui/material";
import { Col, Button, Input as InputStrap, Label } from "reactstrap";

import { getFileTypeMime } from "../../utils";
import toast from "react-hot-toast";
import { lockableFileUpload, tmpDelete } from "../../store/actions/tmpUpload";

const LockableCreator = (props) => {
	const {
		previewData,
		setPreviewData,
		lockableToIPFS,
		ownPinata,
		setLockableToIPFS,
		account,
	} = props;
	const dispatch = useDispatch();

	const { lockable, lockableIsUploading } = useSelector(
		(state) => state.tmpUpload
	);
	const [checkedLock, setCheckedLock] = useState(false); // on/off batch minting
	const sizeLocableLimit = 50 * 1024 * 1024; // Limit for size upload locable file, Mb

	// const InputAsset = styled("input")({
	// 	display: "none",
	// });

	useEffect(() => {
		if (previewData.digitalKey.value || previewData.digitalKey.fileName) {
			setCheckedLock(true);
		}
		if (
			previewData.digitalKey.value.includes(
				`${process.env.REACT_APP_IPFS_HOST}`
			)
		) {
			setLockableToIPFS(true);
		}
	}, [
		previewData,
		previewData.digitalKey.fileName,
		previewData.digitalKey.value,
		setLockableToIPFS,
	]);

	const handleSwitchUnlockable = (event) => {
		setCheckedLock(event.target.checked);
		setPreviewData({
			...previewData,
			digitalKey: { value: "", fileName: "", size: null, type: null },
		});
	};

	const handleDegitalKey = (event) => {
		setPreviewData({
			...previewData,
			digitalKey: {
				value: event.target.value,
				fileName: "",
				size: null,
				type: "text",
			},
		});
	};

	const uploadLockable = (acceptedFiles) => {
		acceptedFiles.forEach((file) => {
			const reader = new FileReader();

			reader.onabort = () => console.log("file reading was aborted");
			reader.onerror = () => console.log("file reading has failed");
			reader.onload = () => {
				// Do whatever you want with the file contents
				const buffer = reader.result;
				upload(file, buffer);
			};
			reader.readAsArrayBuffer(file);
		});

		const upload = (file, buffer) => {
			const fileType = getFileTypeMime(file.type, file.name);
			if (fileType === "unknowtype") {
				toast.error(`This file type is not supported`);
			} else {
				setPreviewData({
					...previewData,
					digitalKey: {
						value: "",
						fileName: file.name,
						size: file.size,
						type: file.type,
						buffer,
					},
				});
				dispatch(lockableFileUpload(file, buffer, account));
			}
		};
	};

	const clearLockable = () => {
		setPreviewData({
			...previewData,
			digitalKey: { value: "", fileName: "", size: null, type: null },
		});
		setLockableToIPFS(false);
		if (lockable.name) {
			dispatch(tmpDelete(lockable.name, "lockable"));
		}
	};

	// console.log("------------------------------------------------");
	// console.log("previewData", previewData);
	// console.log("------------------------------------------------");

	return (
		<>
			<Box
				className="input-mint"
				sx={{
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<Box sx={{ width: "80%" }}>
					<Typography
						className="form-label"
						sx={{
							fontFamily: "Montserrat",
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "20px",
							lineHeight: "25px",
						}}
					>
						Unlock once purchased
					</Typography>
					<Typography
						sx={{
							fontFamily: "Montserrat",
							fontStyle: "normal",
							fontWeight: "normal",
							fontSize: "14px",
							lineHeight: "20px",
							color: "#808080",
						}}
					>
						Content will be unlocked after successful transaction
					</Typography>
				</Box>
				<Box className="form-switch mb-2 ps-0">
					<InputStrap
						style={{
							marginLeft: "8px",
							marginTop: 0,
							width: "45px",
							cursor: "pointer",
						}}
						type="switch"
						name="isLockable"
						checked={checkedLock}
						onChange={handleSwitchUnlockable}
						id="isBatchMint"
						aria-label="controlled"
					/>
				</Box>
			</Box>
			{checkedLock ? (
				<Col md={12} xs={12}>
					{previewData?.digitalKey.size ? (
						<Typography
							component="p"
							sx={{
								width: "100%",
								maxWidth: "490px",
								p: "0.5rem",
								m: "1rem 0",
								border: "1px dashed grey",
							}}
						>
							{previewData?.digitalKey.fileName}
						</Typography>
					) : (
						<>
							<TextField
								id="digitalKey-field"
								multiline
								variant="standard"
								placeholder="Digital key, code to redeem or link to a file..."
								fullWidth
								value={previewData.digitalKey.value}
								onChange={handleDegitalKey}
							/>
							<Typography component="span" className="field-tip">
								Markdown is supported
							</Typography>
						</>
					)}
					<Box
						sx={{
							display: "flex",
							width: "100%",
							columnGap: "1rem",
						}}
					>
						{lockable.name || previewData.digitalKey.fileName ? (
							<FormGroup>
								<FormControlLabel
									sx={{
										fontFamily: "Montserrat",
										width: "100%",
										textAlign: "center",
									}}
									disabled={
										previewData.digitalKey.size > sizeLocableLimit ||
										!lockable.name
									}
									label="Upload to IPFS"
									labelPlacement="end"
									checked={lockableToIPFS}
									control={
										<Switch
											onChange={(event) =>
												setLockableToIPFS(event.target.checked)
											}
										/>
									}
								/>
							</FormGroup>
						) : (
							<Typography
								mb="1rem"
								className="form-label"
								sx={{
									fontFamily: "Montserrat",
									width: "60%",
									textAlign: "center",
								}}
								component="p"
							>
								or uploud lockable content. <br />
								{!ownPinata && "(for IPFS max size is 50mb)"}
							</Typography>
						)}

						<Dropzone onDrop={(acceptedFiles) => uploadLockable(acceptedFiles)}>
							{({ getRootProps, getInputProps }) => (
								<div {...getRootProps()}>
									<Label
										for="input-lockable"
										style={{
											textAlign: "center",
										}}
									>
										<Button
											color="primary"
											tag="span"
											variant="outlined"
											disabled={
												!!previewData?.digitalKey?.size || lockableIsUploading
											}
										>
											Choose file
										</Button>
									</Label>
								</div>
							)}
						</Dropzone>

						{(lockable.name || previewData?.digitalKey.fileName) && (
							<Button
								color="primary"
								tag="span"
								variant="outlined"
								style={{
									marginLeft: "6px",
									height: "33.7px",
								}}
								onClick={clearLockable}
							>
								Clear
							</Button>
						)}
					</Box>
				</Col>
			) : null}
		</>
	);
};

export default LockableCreator;
